// variable paths
export enum RulePath {
  lastEditActionPath = '{.last_edit_action}',
  pipelineStatusPath = '{.pipeline_status}',
  probabilityPath = '{.probability}',
  closedLostReasonPath = '{.closed_lost_reason}',
  pipelineIdPath = '{.pipeline_id}',
}

export const LAST_EDIT_ACTION_CONDITION_INDEX = 0;
export const OPPORTUNITY_STATUS_INDEX = 1;
